import { render } from "./TeamsPanel.vue?vue&type=template&id=2c9f27fa&scoped=true&ts=true&lang=pug"
import script from "./TeamsPanel.vue?vue&type=script&lang=ts"
export * from "./TeamsPanel.vue?vue&type=script&lang=ts"

import "./TeamsPanel.vue?vue&type=style&index=0&id=2c9f27fa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9f27fa"]])

export default __exports__